<template>
  <AuthLayout
    title="Create your account"
    description="Start your free trial. No credit card required."
  >
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-5">
      <BaseButton
        type="button"
        text="Sign in with Google"
        variant="secondary"
        size="md"
        :icon='GoogleColorIcon'
      />
      <BaseButton
        type="button"
        text="Sign in with X"
        variant="secondary"
        size="md"
        :icon='XColorIcon'
      />
    </div>

    <div class="relative py-3 sm:py-5">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-gray-200 dark:border-gray-800"></div>
      </div>
      <div class="relative flex justify-center text-sm">
        <span class="p-2 text-gray-400 bg-white dark:bg-gray-900 sm:px-5 sm:py-2"
          >Or</span
        >
      </div>
    </div>

    <form @submit.prevent="handleSubmit">
      <div class="space-y-5">
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <TextInputDefault
            labelText="First Name"
            placeholder="Enter your first name"
            id="firstName"
            name="firstname"
            type="text"
            v-model="email"
            asterisk
          />

          <TextInputDefault
            labelText="Last Name"
            placeholder="Enter your last name"
            id="lastName"
            name="lastname"
            type="text"
            v-model="email"
            asterisk
          />
        </div>

        <TextInputDefault
          labelText="Email"
          placeholder="Enter your Email"
          id="loginEmail"
          name="loginemail"
          type="text"
          v-model="email"
          iconPosition="right"
          asterisk
        >
          <template #icon>
            <EnvelopeIcon />
          </template>
        </TextInputDefault>
        
        <TextInputDefault
          labelText="Password"
          placeholder="Enter your password"
          id="password"
          name="password"
          type="password"
          v-model="password"
          icon="eye"
          asterisk
        />

        <!-- Checkbox -->
        <div>
          <div>
            <label
              for="checkboxLabelOne"
              class="flex items-start text-sm font-normal text-gray-700 cursor-pointer select-none dark:text-gray-400"
            >
              <div class="relative">
                <input
                  v-model="agreeToTerms"
                  type="checkbox"
                  id="checkboxLabelOne"
                  class="sr-only"
                />
                <div
                  :class="
                    agreeToTerms
                      ? 'border-brand-500 bg-brand-500'
                      : 'bg-transparent border-gray-300 dark:border-gray-700'
                  "
                  class="mr-3 flex h-5 w-5 items-center justify-center rounded-md border-[1.25px]"
                >
                  <span :class="agreeToTerms ? '' : 'opacity-0'">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
                        stroke="white"
                        stroke-width="1.94437"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <p class="inline-block font-normal text-gray-500 dark:text-gray-400">
                By creating an account means you agree to the
                <span class="text-gray-800 dark:text-white/90">
                  Terms and Conditions,
                </span>
                and our
                <span class="text-gray-800 dark:text-white"> Privacy Policy </span>
              </p>
            </label>
          </div>
        </div>
        <!-- Button -->
        <div>
          <BaseButton
            type="submit"
            text="Sign Up"
            variant="primary"
            size="md"
            class="w-full"
          />
        </div>
      </div>
    </form>

    <div class="mt-5">
      <p
        class="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start"
      >
        Already have an account?
        <router-link
          to="/"
          class="text-brand-500 hover:text-brand-600 dark:text-brand-400"
          >Sign In</router-link
        >
      </p>
    </div>

  </AuthLayout>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import AuthLayout from '@/components/layout/AuthLayout.vue'
import TextInputDefault from '@/components/forms/TextInputDefault.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import {
  EnvelopeIcon,
  GoogleColorIcon,
  XColorIcon
} from '@/icons';

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const password = ref('')
const agreeToTerms = ref(false)

const handleSubmit = () => {
  // Implement form submission logic here
  console.log('Form submitted', {
    firstName: firstName.value,
    lastName: lastName.value,
    email: email.value,
    password: password.value,
    agreeToTerms: agreeToTerms.value,
  })
}
</script>
